import React, { Fragment, useState, useEffect } from 'react';
import CareersTemp from '../../components/CareersTemplate/CareersTemp';
import JobsCard from '../../components/ReusableGeneric/JobsCard';
import { careerOpportunitiesObj } from "./CareersConstants";
import { Disclosure } from '@headlessui/react'
import { ChevronUpIcon } from '@heroicons/react/solid';
import axios from "axios";
import appConfig from '../../config';

// cow 57 
// buff 64
// client cash Daily 


const inputBoxFilterIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 22 22" stroke="white" stroke-width="2" transform='rotate(180)'>
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
        </svg>
    )
}
const crossIcon = (size) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" class={`h-${size} w-${size}`} viewBox="0 0 18 18" fill="currentColor">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
    )
}
const noResultsIcon = () => {
    return (
        <svg width="80" height="74" viewBox="0 0 80 74" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M24.6502 0.320098C24.2929 0.510378 23.9433 0.872968 23.7512 1.25274C23.4619 1.82437 23.4367 2.17845 23.4367 5.66403V9.45388H12.6426C2.13295 9.45388 1.83214 9.46224 1.23146 9.77123C0.831052 9.97727 0.502099 10.3105 0.294783 10.7204C-0.0179101 11.3384 -0.0238513 11.5517 0.0189877 20.5319L0.0629211 29.7116L0.421111 30.3881C0.906255 31.3041 1.79227 32.1673 2.72738 32.6347L3.50255 33.0222L24.0193 33.0644L44.5362 33.1067L44.6036 32.7491C44.6408 32.5526 44.7854 31.6879 44.925 30.8279C45.9222 24.687 50.0731 19.1007 55.6989 16.3286C58.8457 14.7781 61.1207 14.2593 64.7123 14.2729C67.1288 14.282 67.8794 14.372 69.9236 14.8982L70.3664 15.0122L70.3145 12.9819C70.2685 11.1825 70.2229 10.8954 69.9139 10.4586C69.1764 9.4162 69.6337 9.45388 57.6996 9.45388H46.9038L46.8572 5.47328C46.8124 1.6467 46.7971 1.4736 46.4619 0.999716C45.7282 -0.0374473 46.0884 -0.00575986 35.1391 0.00196487C25.587 0.00874372 25.2139 0.0200943 24.6502 0.320098ZM42.1983 7.08917V9.45388H35.1627H28.1271V7.08917V4.72446H35.1627H42.1983V7.08917ZM62.7579 19.0242C58.7969 19.5662 55.1096 21.6388 52.6734 24.6924C46.4921 32.4402 48.996 43.8852 57.8483 48.3471L59.2401 49.0486V51.716V54.3834H64.7123H70.1844V51.6536V48.9238L71.0196 48.5748C74.147 47.2677 77.324 43.9916 78.7356 40.6184C82.6552 31.2512 77.0849 20.8701 67.2254 19.1673C65.8653 18.9324 63.8908 18.8691 62.7579 19.0242ZM67.9389 24.1957C69.7369 24.8036 70.7341 25.4351 72.1498 26.8627C73.5584 28.2828 74.1767 29.2719 74.8179 31.1304C75.2073 32.2593 75.253 32.6066 75.253 34.441C75.253 36.2754 75.2073 36.6227 74.8179 37.7516C74.1767 39.6101 73.5584 40.5992 72.1498 42.0193C70.7394 43.4416 69.7565 44.0657 67.9174 44.7067C66.7998 45.0963 66.4501 45.1426 64.6341 45.1417C62.808 45.1406 62.4682 45.0947 61.2881 44.6884C58.1029 43.5923 55.5577 41.0241 54.4686 37.8071C54.0683 36.6248 54.0228 36.2814 54.0228 34.441C54.0228 32.598 54.068 32.2582 54.4712 31.0672C55.7248 27.3633 59.0012 24.4821 62.7301 23.8045C64.1453 23.5473 66.5567 23.7284 67.9389 24.1957ZM0.0216456 52.4802C0.0629211 68.3766 0.0632338 68.3914 0.392031 68.8361C0.572924 69.0809 0.959882 69.423 1.25194 69.5964C1.77632 69.9079 2.10184 69.9122 28.1675 69.9533L54.5522 69.995L54.5119 60.9771L54.4716 51.9591L53.3771 51.2004C51.9242 50.1929 50.0469 48.4524 48.9882 47.1312C47.193 44.8909 45.6753 41.7453 45.0903 39.0522L44.8248 37.8304H43.5117H42.1983V41.6203C42.1983 45.1075 42.1732 45.4598 41.8836 46.0322C41.681 46.4328 41.3489 46.7676 40.9516 46.972C40.37 47.2712 40.0376 47.2893 35.1512 47.2893C27.8041 47.2893 28.1271 47.55 28.1271 41.6203V37.8304H16.0819C3.01021 37.8304 2.63013 37.8085 0.869357 36.9519C0.43659 36.7414 0.0596378 36.5693 0.0314954 36.5693C0.00335302 36.5693 -0.00102469 43.7291 0.0216456 52.4802ZM32.8175 40.1952V42.5599H35.1627H37.5079V40.1952V37.8304H35.1627H32.8175V40.1952ZM59.2401 64.3881C59.2401 69.4046 59.2567 69.708 59.5772 70.5718C60.0075 71.7315 61.1776 72.997 62.3495 73.5706C63.1058 73.9407 63.4213 74 64.6341 74C65.8456 74 66.1627 73.9406 66.9155 73.572C68.5968 72.7492 69.7177 71.221 70.0207 69.3382C70.1093 68.7866 70.1825 66.2601 70.1831 63.7241L70.1844 59.1129H64.7123H59.2401V64.3881Z" fill="#25AAE1" />
        </svg>

    )
}
const loadSpinner = () => {
    return (
        <svg role="status" className="right-0 w-10 h-10 text-gray-200 animate-spin  fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
        </svg>
    )
}
function CareerOpportunities() {
    const [openTab, setOpenTab] = useState(0);
    const [currPageNumber, setcurrPageNumber] = useState(1);
    const [totalJobsCount, setTotalJobsCount] = useState(0);
    const [openFilterInputs, setOpenFilterInputs] = useState(false);
    const [appliedFiltersList, setappliedFiltersList] = useState([]);
    const [filteredSearchesList, setfilteredSearchesList] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [noFilteredDataFound, setnoFilteredDataFound] = useState(false);
    const [showResults, setshowResults] = useState(false);
    const [appliedFilters, setappliedFilter] = useState({
        "Location": "",
        "Department": "",
        "Worktype": ""
    })
    const [isFiltersApplied, setisFiltersApplied] = useState(false);

    const tabDepartmentMap = [
        "",
        "Engineering",
        "Sales and Marketing",
        "AI and Data Science",
        "Product Team",
        "Marketing",
        "Customer Success"
    ];
    const filtersList = [
        {
            name: "Location",
            list: careerOpportunitiesObj.LocationList
        },
        {
            name: "Department",
            list: careerOpportunitiesObj.departmentsList
        },
        {
            name: "Work type",
            list: careerOpportunitiesObj.WorkTypeList
        }
    ];

    const addFilters = (parentFilterName, childFilterName) => {
        setisFiltersApplied(true);
        if (!appliedFiltersList.includes(childFilterName)) setappliedFiltersList([...appliedFiltersList, childFilterName]);
        if (parentFilterName === "Location") setappliedFilter({ ...appliedFilters, "Location": childFilterName });
        else if (parentFilterName === "Department") setappliedFilter({ ...appliedFilters, "Department": childFilterName });
        else if (parentFilterName === "Work type") setappliedFilter({ ...appliedFilters, "Worktype": childFilterName });
    }
    const handleApplyFilters = async () => {
        setisLoading(true);
        const res = await axios({
            method: "get",
            url: `${appConfig.domain[appConfig.environment]["agribazaar"]}/agribazaarJobListFilter.php?location=${appliedFilters.Location}&department=${appliedFilters.Department}&jobtype=${appliedFilters.Worktype}`
        })
        setisLoading(false);
        if (res.data.status) {
            setfilteredSearchesList(res.data.data);
            if (res.data.data) {
                setshowResults(true);
                setnoFilteredDataFound(false);
            }
            else {
                setshowResults(false);
                setnoFilteredDataFound(true);
            }
        }
    }

    const getJobsList = async (index) => {
        setisLoading(true);
        setfilteredSearchesList([]);
        const res = await axios.get(
            `${appConfig.domain[appConfig.environment]["agribazaar"]}/agribazaarJobList.php?page=${currPageNumber}&cat=${tabDepartmentMap[index]}`
        );
        postGettingJobsList(res.data);
        setisLoading(false);
    }
    const postGettingJobsList = (data) => {
        if (data.status) {
            setTotalJobsCount(data.total);
            setfilteredSearchesList(data.data);
        }
    }

    useEffect(() => {
        getJobsList(openTab);
    }, []);

    const ifAllFiltersRemoved = () => {
        setshowResults(false);
        setnoFilteredDataFound(false);
        setisFiltersApplied(false);
    }

    const headerContent = () => {
        return (
            <div id="top-data" style={{ backgroundImage: 'url(' + careerOpportunitiesObj.topImgUrl + ')', }} className={`w-full relative bg-cover bg-center`}>
                <div className='p-20 text-center flex items-center place-items-center sm:hidden' />
                <div className='py-20 px-60 text-center hidden sm:flex text-white'>
                    <p className='hidden sm:block font-medium text-5xl'>{careerOpportunitiesObj.topTitle}</p>
                </div>
            </div>
        )
    }
    const bodyContent = () => {
        return (
            <div id="body-data" className='w-full sm:px-16'>
                <div className="flex flex-wrap">
                    <div className="w-full hidden sm:block">
                        <ul
                            className="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
                            role="tablist"
                        >
                            {careerOpportunitiesObj.departmentsList.map((item, index) =>
                            (
                                <li className="-mb-px mr-2 last:mr-0 flex-auto text-center px-2 text-[#3B3939]">
                                    <a
                                        className={`text-xs font-bold px-5 py-3 shadow-md block leading-normal ${openTab === index+1 && 'bg-[#f8d49a]'}`}
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(index+1);
                                            getJobsList(index+1);
                                            // setTimeout(() => getJobsList(), 0);
                                        }}
                                        data-toggle="tab"
                                        href="#link1"
                                        role="tablist"
                                    >
                                        {item}
                                    </a>
                                </li>
                            )
                            )}
                        </ul>
                        <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6">
                            <div className="px-4 py-5 flex-auto">
                                <div className="tab-content tab-space">
                                    <RenderSelectedTabData />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='sm:hidden text-[#3B3939] px-4 w-full'>
                        <div id="top" className='w-full flex flex-row justify-between py-4 px-4'>
                            <div className='text-lg font-medium'>Job Openings</div>
                            <div className='text-lg font-medium'>{totalJobsCount} Job(s)</div>
                        </div>
                        <div id="filter" className='w-full'>
                            <div className="flex flex-col items-center justify-center">
                                <div className="flex w-full">
                                    <input type="text" className="px-4 py-3 w-full border-2 border-[#CBCBCB] border-r-0 rounded-l-lg text-md placeholder:text-md placeholder:text-[#3B3939] placeholder:font-medium" placeholder="Search job" />
                                    <button className="flex items-center justify-center px-4 border-0 rounded-r-lg bg-[#ED1849]" onClick={() => setOpenFilterInputs(!openFilterInputs)}>
                                        {inputBoxFilterIcon()}
                                    </button>
                                </div>
                                {openFilterInputs &&
                                    <div className='w-full pt-2'>
                                        {isFiltersApplied && (<div id="top" className='w-full flex flex-row justify-between pt-2 px-4 items-center'>
                                            <div className='text-md font-semibold'>Clear Filters</div>
                                            <div className='text-md font-semibold' onClick={() => {
                                                setshowResults(false);
                                                setnoFilteredDataFound(false);
                                                setappliedFilter({
                                                    "Location": "",
                                                    "Department": "",
                                                    "Worktype": ""
                                                })
                                            }
                                            }>{crossIcon(5)}</div>
                                        </div>)}
                                        <div className="w-full max-w-md mx-auto bg-white rounded-2xl ">
                                            {
                                                filtersList.map((item, index) => (
                                                    <Disclosure as="div" className="mt-2" id={index}>
                                                        {({ open }) => (
                                                            <>
                                                                <Disclosure.Button className="flex flex-col px-4 py-3.5 border-2 border-[#CBCBCB]  justify-between w-full text-sm font-medium text-left rounded-lg focus:outline-none focus-visible:ring focus-visible:ring-opacity-75">
                                                                    <div className='flex flex-row justify-between w-full text-base text-[#3B3939] font-thin'>
                                                                        <div><span>{item.name}</span></div>
                                                                        <div><ChevronUpIcon
                                                                            className={`${!open ? 'transform rotate-180' : ''
                                                                                } w-5 h-5`}
                                                                        /></div>
                                                                    </div>
                                                                    <Disclosure.Panel className="w-full px-4 pt-4 pb-2 text-md text-[#3B3939]">
                                                                        <ul>
                                                                            {item.list.map((items, index) => (
                                                                                <li
                                                                                    onClick={() => {
                                                                                        addFilters(item.name, items);
                                                                                    }}
                                                                                    id={`${item}_${items}`} key={`_${index}__${items}`} className='py-1 text-base font-extralight leading-relaxed'
                                                                                >
                                                                                    {items}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </Disclosure.Panel>
                                                                </Disclosure.Button>
                                                            </>
                                                        )}
                                                    </Disclosure>
                                                ))
                                            }
                                        </div>
                                    </div>
                                }
                                <div className='pt-2 flex flex-col items-start w-full'>
                                    <div className='w-full items-start flex flex-wrap gap-2 relative overflow-hidden p-2'>
                                        {/* {appliedFiltersList.map((item, index) =>
                                        (
                                            <div key={index} id={item} className='bg-[#E2E2E2] h-min py-2 rounded-xl  w-max flex flex-row gap-3 justify-between pt-2 px-2 items-start'>
                                                <div className='text-sm font-normal text-ellipsis'>{item}</div>
                                                <button onClick={() => {
                                                    setappliedFiltersList(appliedFiltersList.filter(val => val !== item));
                                                    if (appliedFiltersList.length === 1) {
                                                        setshowResults(false);
                                                        setnoFilteredDataFound(false);
                                                        setfilteredSearchesList([]);
                                                    }
                                                }}>{crossIcon(4)}</button>
                                            </div>
                                        ))} */}
                                        {appliedFilters.Location && (<div className='bg-[#E2E2E2] h-min py-2 rounded-xl  w-max flex flex-row gap-3 justify-between pt-2 px-2 items-start'>
                                            <div className='text-sm font-normal text-ellipsis'>{appliedFilters.Location}</div>
                                            <button
                                                onClick={() => {
                                                    setappliedFilter({ ...appliedFilters, "Location": "" });
                                                    if (appliedFilters.Department === "" && appliedFilters.Worktype === "") ifAllFiltersRemoved();
                                                }}

                                            >{crossIcon(4)}</button>
                                        </div>)}
                                        {appliedFilters.Department && (<div className='bg-[#E2E2E2] h-min py-2 rounded-xl  w-max flex flex-row gap-3 justify-between pt-2 px-2 items-start'>
                                            <div className='text-sm font-normal text-ellipsis'>{appliedFilters.Department}</div>
                                            <button
                                                onClick={() => {
                                                    setappliedFilter({ ...appliedFilters, "Department": "" });
                                                    if (appliedFilters.Location === "" && appliedFilters.Worktype === "") ifAllFiltersRemoved();
                                                }}

                                            >{crossIcon(4)}</button>
                                        </div>)}
                                        {appliedFilters.Worktype && (<div className='bg-[#E2E2E2] h-min py-2 rounded-xl  w-max flex flex-row gap-3 justify-between pt-2 px-2 items-start'>
                                            <div className='text-sm font-normal text-ellipsis'>{appliedFilters.Worktype}</div>
                                            <button
                                                onClick={() => {
                                                    setappliedFilter({ ...appliedFilters, "Worktype": "" });
                                                    if (appliedFilters.Department === "" && appliedFilters.Location === "") ifAllFiltersRemoved();
                                                }}

                                            >{crossIcon(4)}</button>
                                        </div>)}
                                    </div>
                                </div>
                                {isFiltersApplied && (<div className='pt-4'>
                                    <button
                                        onClick={handleApplyFilters}
                                        className="whitespace-nowrap inline-flex justify-center px-6 py-2 border border-transparent rounded-md shadow-sm text-sm text-white bg-[#ED1849]"
                                    >
                                        Apply Filters
                                    </button>
                                </div>)}
                            </div>
                        </div>
                        <div id="search-results" className='w-full pt-12 flex flex-col items-center'>
                            {isLoading && loadSpinner()}
                            {(filteredSearchesList?.length > 0 && isFiltersApplied && showResults) && <RenderSelectedTabData />}
                            {(noFilteredDataFound && isFiltersApplied) &&
                                <Fragment>
                                    <div className=' items-center flex flex-col gap-3 pb-8'>
                                        <div>
                                            {noResultsIcon()}
                                        </div>
                                        <div className='text-base font-semibold px-14 text-center'>
                                            <p>Sorry, no jobs found matching this criteria</p>
                                        </div>
                                        <div>
                                            <button
                                                onClick={() => {
                                                    setshowResults(false);
                                                    setnoFilteredDataFound(false);
                                                    setappliedFilter({
                                                        "Location": "",
                                                        "Department": "",
                                                        "Worktype": ""
                                                    });
                                                    ifAllFiltersRemoved();
                                                }}
                                                className="whitespace-nowrap inline-flex justify-center px-6 py-2 border border-transparent rounded-md shadow-sm text-sm text-white bg-[#ED1849]"
                                            >
                                                Clear Filters
                                            </button>
                                        </div>
                                    </div>
                                </Fragment>}
                        </div>
                    </div>
                </div>
            </div >
        )
    }
    const RenderSelectedTabData = () => {
        return (
            <div>
                <div className='flex flex-col items-center pb-4'>{isLoading && loadSpinner()}</div>
                {!filteredSearchesList?.length > 0 ? <Fragment>
                    {!isLoading && (<div className=' items-center flex flex-col gap-3 pb-8'>
                        <div>
                            {noResultsIcon()}
                        </div>
                        <div className='text-base font-semibold px-14 text-center'>
                            <p>Sorry, no jobs found for&nbsp;{tabDepartmentMap[openTab]}</p>
                        </div>
                    </div>)}
                </Fragment> : filteredSearchesList.map((item, index) => (
                    <JobsCard jobObj={item} key={`__${item.jobId}__${index}`} />
                ))}
            </div>
        )
    }
    return (
        <div>
            <CareersTemp currentPageTitle={careerOpportunitiesObj.navSeq} headerContent={headerContent()} bodyContent={bodyContent()} />
        </div>
    );
}

export default CareerOpportunities;